import React from 'react';
import Svg, { Mask, Path, Rect, ClipPath, G, Defs, Image } from 'react-native-svg';

export function NinjacartLogo({ width, height }) {
  return (
    <>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 538 538"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          d="M78.2869 115.5C69.5169 106.73 68.2569 93.3199 74.4469 83.1899C25.4469 134.45 -0.963144 201.56 0.026856 272.7C0.996856 342.53 28.8669 408.45 78.4969 458.33C80.0169 459.86 81.5669 461.37 83.1169 462.86C93.2869 469.24 106.857 468.03 115.707 459.18C124.627 450.26 125.797 436.54 119.247 426.35C117.787 424.96 116.327 423.55 114.897 422.11C74.7169 381.73 52.1569 328.42 51.3769 271.99C50.5769 214.56 71.8469 160.37 111.317 118.94C101.107 125.63 87.2669 124.49 78.2969 115.51L78.2869 115.5Z"
          fill="#2B3F94"
        />
        <Path
          d="M115.707 459.17C106.857 468.02 93.2867 469.23 83.1167 462.85C132.177 509.9 196.057 536.42 263.727 537.69C265.407 537.72 267.087 537.74 268.767 537.74C313.137 537.74 357.107 526.72 395.917 505.88C401.957 502.64 406.377 497.23 408.357 490.67C410.337 484.1 409.637 477.16 406.397 471.12C403.157 465.08 397.747 460.66 391.187 458.68C384.617 456.7 377.677 457.4 371.637 460.64C339.017 478.16 302.047 487.02 264.707 486.35C210.297 485.33 158.887 464.07 119.257 426.34C125.807 436.53 124.637 450.25 115.717 459.17H115.707Z"
          fill="#E30D7F"
        />
        <Path
          d="M422.117 78.45C430.987 69.58 444.607 68.38 454.787 74.82C406.467 28.5 340.937 0 268.877 0C196.817 0 128.367 28.44 77.437 80.08C76.427 81.1 75.447 82.14 74.457 83.18C68.267 93.32 69.5271 106.72 78.2971 115.49C87.2671 124.46 101.107 125.6 111.317 118.92C112.207 117.99 113.087 117.06 113.997 116.14C155.197 74.36 210.207 51.35 268.877 51.35C327.547 51.35 379.467 74.1 418.487 111.12C412.057 100.94 413.257 87.33 422.127 78.46L422.117 78.45Z"
          fill="#F79A23"
        />
        <Path
          d="M454.787 74.8201C444.607 68.3801 430.987 69.5801 422.117 78.4501C413.247 87.3201 412.047 100.94 418.477 111.11C460.277 150.77 486.387 206.82 486.387 268.86C486.387 330.9 436.527 379.84 391.947 379.84C370.897 379.84 353.387 372.4 336.837 356.42C330.407 350.21 324.437 342.69 319.077 334.05L204.557 149.46C198.537 139.76 186.667 135.18 175.707 138.31C164.737 141.44 157.067 151.59 157.067 163V405.73C157.067 419.89 168.587 431.4 182.737 431.4C196.887 431.4 208.407 419.88 208.407 405.73V253.09L275.437 361.13C283.027 373.37 291.687 384.21 301.157 393.36C327.517 418.82 357.217 431.19 391.937 431.19C431.597 431.19 468.957 412.71 497.117 379.14C522.927 348.38 537.727 308.18 537.727 268.86C537.727 192.67 505.867 123.78 454.767 74.8101L454.787 74.8201Z"
          fill="#30B14B"
        />
        <Path
          d="M386.187 228.16C386.377 225.24 386.477 222.3 386.477 219.33C386.477 206.3 384.577 193.72 381.047 181.84L357.827 205.06V256.53L386.187 228.17V228.16Z"
          fill="#007D3F"
        />
        <Path
          d="M353.487 137.39C344.087 149.17 336.677 162.6 331.747 177.18L353.487 198.92V137.39Z"
          fill="#007D3F"
        />
        <Path
          d="M357.827 137.39V198.92L379.567 177.18C374.637 162.61 367.227 149.18 357.827 137.39Z"
          fill="#007D3F"
        />
        <Path
          d="M357.827 262.65V301.26C372.697 282.61 382.607 259.83 385.557 234.92L357.827 262.65Z"
          fill="#007D3F"
        />
        <Path
          d="M353.487 256.52V205.05L330.267 181.83C326.737 193.71 324.837 206.29 324.837 219.32C324.837 222.29 324.937 225.23 325.127 228.15L353.487 256.51V256.52Z"
          fill="#007D3F"
        />
        <Path
          d="M325.767 234.93C328.717 259.84 338.617 282.62 353.497 301.27V262.66L325.767 234.93Z"
          fill="#007D3F"
        />
      </Svg>
    </>
  );
}
